// -------------------------------------
// Dependencies
// -------------------------------------
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
iamotaEventHandler.subscribe('productForm:init', _ref => {
  var {
    iamForm
  } = _ref;
  var sellingPlan = iamForm.getCurrentSellingPlan();
  updateOrdergrooveOfferWithFrequency(sellingPlan);
}, {
  source: "ordergroove-offer--show-frequency.js"
});
iamotaEventHandler.subscribe('productForm:sellingPlan:changed', _ref2 => {
  var {
    sellingPlan
  } = _ref2;
  updateOrdergrooveOfferWithFrequency(sellingPlan);
}, {
  source: "ordergroove-offer--show-frequency.js"
});
function updateOrdergrooveOfferWithFrequency(sellingPlan) {
  var optinButtons = document.querySelectorAll('.ordergroove__offer--pdp:not(.ordergroove__offer--pdp-trial) og-optin-button');
  var sellingPlanSubtitles = document.querySelectorAll('.ordergroove__offer--pdp:not(.ordergroove__offer--pdp-trial) .selling-plan__subtitle');
  if (!sellingPlan || sellingPlan.purchase_type === 'onetime') return;
  optinButtons.forEach((optinButton, index) => {
    var subtitle = sellingPlanSubtitles[index];

    // Remove old subtitle if it doesn't match current label
    if (subtitle && subtitle.textContent !== sellingPlan.label) {
      subtitle.remove();
    }

    // Insert new subtitle if not already present
    if (!subtitle || subtitle.textContent !== sellingPlan.label) {
      var span = document.createElement('span');
      span.textContent = sellingPlan.label;
      span.classList.add('selling-plan__subtitle', 'h5');
      optinButton.parentNode.insertBefore(span, optinButton.nextSibling);
    }
  });
}